import { ComponentPropertyDefinition } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { produce } from 'immer';
import migrateUniqueItemsByKey from './migrateUniqueItemsByKey';

function migrateComponentPropertyDefinitions(properties: ComponentPropertyDefinition[]): ComponentPropertyDefinition[] {
  return produce(properties, (draftProperties) => {
    // Delete broken and non-recoverable component property definitions without `name` property
    for (let index = draftProperties.length - 1; index >= 0; index -= 1) {
      const property = draftProperties[index];
      if (property.name == null) {
        draftProperties.splice(index, 1);
      }
    }
    // Ensure unique property names
    migrateUniqueItemsByKey('name', draftProperties);
  });
}

export default migrateComponentPropertyDefinitions;
